import React, {createContext, useContext, useEffect, useState} from 'react';
import {isEmpty} from 'lodash';
import axios from 'axios';
import LocalStorage from 'utils/localStorage';
import {LoadingPage} from 'components/Loading';

const LocaleContext = createContext({});

// If load locale from IP is failed, set `in_eu` to true by default
// This is to ensure that the default checked in consent is disabled for EU users
const initialLocale = {
  in_eu: true,
  country_calling_code: '',
  country_code: '',
  country_name: '',
  languages: 'en-GB',
};

function LocaleProvider(props) {
  const {children} = props;

  const storedData = LocalStorage.locale || null;

  const [isLoading, setIsLoading] = useState(isEmpty(storedData));
  const [locale, setLocale] = useState(storedData);

  useEffect(() => {
    if (isEmpty(storedData)) {
      fetchLocale();
    } else {
      setIsLoading(false);
    }
  }, []);

  async function fetchLocale() {
    let instance = axios.create();

    instance.interceptors.request.use((config) => {
      delete config.headers.common['x-http-bsid']; // Remove
      delete config.headers.common['x-http-token']; // Remove
      config.withCredentials = false; // 3rd party request does not need credentials
      return config;
    });

    try {
      const {data} = await instance.get('https://ipapi.co/json');
      const {
        country_calling_code,
        country_code,
        country_name,
        languages,
        in_eu, // GDPR compliance - EU `in_eu` is true, non-EU `in_eu` is false
      } = data;

      const newLocale = {
        country_calling_code,
        country_code,
        country_name,
        languages,
        in_eu,
      };

      LocalStorage.locale = newLocale; // Set localstorage
      setLocale(newLocale);
      setIsLoading(false);
    } catch (e) {
      LocalStorage.locale = initialLocale; // Set localstorage
      setLocale(initialLocale);
      setIsLoading(false);
    }
  }

  return (
    <LocaleContext.Provider value={{isLoading, locale}}>
      {isLoading ? <LoadingPage /> : children}
    </LocaleContext.Provider>
  );
}

const useLocale = () => useContext(LocaleContext);

export {LocaleContext, LocaleProvider, useLocale};
